import { makeImmutable, toPairs } from "../../core";
import { RadioFieldControler } from "../../form";
export class PaymentFormControler {
    constructor(params) {
        this.paymentMediumController = new RadioFieldControler({
            initialValue: this.getInitialValue(params.paymentMediums, params.fulfillmentInstructions.paymentMedium),
            update: (value) => {
                params.fulfillmentInstructions.paymentMedium = value.domainValue;
            },
        });
        makeImmutable(this);
    }
    touch() {
        toPairs(this.fields).forEach(([_, field]) => field.onBlur());
    }
    get fields() {
        return {
            paymentMedium: this.paymentMediumController,
        };
    }
    getInitialValue(paymentMediums, domain) {
        if (paymentMediums === null || domain === null) {
            return null;
        }
        const medium = paymentMediums.raw.find((medium) => medium.isSelected(domain)) || null;
        if (medium === null) {
            return null;
        }
        return medium.kind === "OnlineGroup" ? medium.getChannel(domain) : medium;
    }
}
